import {PropsWithChildren, useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';

export interface ClientOnlyPortalProps {
  selector: string;
}

export function ClientOnlyPortal({children, selector}: PropsWithChildren<ClientOnlyPortalProps>): JSX.Element | null {
  const containerRef = useRef<Element | null>(null);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    containerRef.current = document.querySelector<Element>(selector);
    setMounted(true);
  }, [selector]);

  return mounted && containerRef.current ? createPortal(children, containerRef.current) : null;
}
